import React, { useEffect } from 'react';
import { WindowShade } from '@sas/nova-commons/components/WindowShade';
import { AboutInfoState } from '../../store/aboutInfo/AboutInfoState';
import { BirdLayoutState } from '../../store/birdLayout/BirdLayoutState';
import { useDesignTokens } from '@sas/nova-commons/theme';
import { selectAboutInfoState } from '../../store/selectors';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
export const BirdAboutInfoBase = function ({ id, aboutInfo, actions }) {
    useEffect(() => {
        if (aboutInfo && aboutInfo.value) {
            const headerHeight = 32;
            const contentHeight = aboutInfo.isOpen
                ? 14 + // margin-top
                    18 * aboutInfo.value.messages.length + // height of each message
                    30 // margin-bottom
                : 0;
            actions.setAboutInfoLayout(id, { height: headerHeight + contentHeight });
        }
    }, [aboutInfo, actions, id]);
    const dt = useDesignTokens();
    return (aboutInfo === null || aboutInfo === void 0 ? void 0 : aboutInfo.value) ? (React.createElement(WindowShade, { openSections: aboutInfo.isOpen ? [0] : [], onToggleSection: () => actions.toggleOpen(id), sections: [
            {
                header: aboutInfo.value.label,
                content: (React.createElement("ul", { style: {
                        marginTop: '1em',
                        marginBottom: 'calc(1em + 1rem)',
                        listStyleType: 'disc',
                        color: dt.reportTokens.stateStandardContent.normal.fg,
                        fontSize: '0.875rem',
                    } }, aboutInfo.value.messages.map((m, i) => (React.createElement("li", { key: i }, m))))),
            },
        ] })) : null;
};
export const BirdAboutInfo = connect((state, props) => ({
    aboutInfo: selectAboutInfoState(state, props.id),
}), (dispatch) => ({
    actions: bindActionCreators(Object.assign({ setAboutInfoLayout: BirdLayoutState.actions.setAboutInfoLayout }, AboutInfoState.actions), dispatch),
}))(BirdAboutInfoBase);
